module.exports = __webpack_public_path__ + "img/zt_pic4.6eb25e43.jpg";